<div>
    <ng-container *ngFor="let section of data">
        <me-landing-page-image-text *ngIf="section.component === 'landingPageImageText'" [data]="section"></me-landing-page-image-text>
        <me-landing-page-product-presentation *ngIf="section.component === 'productPresentation'" [data]="section"></me-landing-page-product-presentation>
        <me-landing-page-product-offer *ngIf="section.component === 'productOffer'" [data]="section"></me-landing-page-product-offer>
    </ng-container>
</div>